import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router';
import { PagePath } from '@routing/appUrls';
import Navbar from '@components/features/navigation/Navbar';

interface Props {
    children: ReactNode;
}

const Layout: FC<Props> = ({ children }) => {
    const location = useLocation();
    const pagePathsWithoutNavigation: Array<string> = [
        PagePath.documentExternalView,
        PagePath.selectProject,
    ];
    const showNavigation = !pagePathsWithoutNavigation.includes(
        location.pathname,
    );

    return (
        <>
            {showNavigation && <Navbar />}
            <main className="layout__main">
                {children}
            </main>
        </>
    );
};

export default Layout;
